import { render, staticRenderFns } from "./MeetingFollowUps.vue?vue&type=template&id=062f3aa6&scoped=true"
import script from "./MeetingFollowUps.vue?vue&type=script&lang=js"
export * from "./MeetingFollowUps.vue?vue&type=script&lang=js"
import style0 from "./MeetingFollowUps.vue?vue&type=style&index=0&id=062f3aa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062f3aa6",
  null
  
)

export default component.exports